import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/uptime/view/detail/uptime.view.detail.query.gql"
import type {
  UptimeViewDetailQuery,
  UptimeViewDetailQueryVariables,
} from "@/v2-backoffice-client/uptime/view/detail/__types__/uptime.view.detail.query"

type Options = QueryHookOptions<
  UptimeViewDetailQuery,
  UptimeViewDetailQueryVariables
>

// useUptimeViewDetailQuery powers the per-target detail sheet. The
// resolver returns the full UptimeTargetFragment plus the
// availability rollup and the incident timeline for the target, so
// the whole sheet body can mount from a single network round-trip.
export function useUptimeViewDetailQuery(options?: Options) {
  return useQuery<UptimeViewDetailQuery, UptimeViewDetailQueryVariables>(
    query,
    options,
  )
}
